"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Route = void 0;
const config_1 = require("./config");
const utils_1 = require("./utils");
class Route {
    constructor(routeName) {
        this.routeName = routeName;
    }
    post(endpoint, body) {
        return config_1.configInstance.axiosInstance.post(`${this.getBaseUrl()}${this.routeName}${endpoint}`, body, utils_1.getRequestConfig(config_1.configInstance.getOptions(), config_1.configInstance.getAuthToken()));
    }
    put(endpoint, body) {
        return config_1.configInstance.axiosInstance.put(`${this.getBaseUrl()}${this.routeName}${endpoint}`, body, utils_1.getRequestConfig(config_1.configInstance.getOptions(), config_1.configInstance.getAuthToken()));
    }
    delete(endpoint, urlParams) {
        const reqConfig = utils_1.getRequestConfig(config_1.configInstance.getOptions(), config_1.configInstance.getAuthToken());
        reqConfig.params = urlParams;
        return config_1.configInstance.axiosInstance.delete(`${this.getBaseUrl()}${this.routeName}${endpoint}`, reqConfig);
    }
    get(endpoint, urlParams) {
        const reqConfig = utils_1.getRequestConfig(config_1.configInstance.getOptions(), config_1.configInstance.getAuthToken());
        reqConfig.params = urlParams;
        return config_1.configInstance.axiosInstance.get(`${this.getBaseUrl()}${this.routeName}${endpoint}`, reqConfig);
    }
    getBaseUrl() {
        return config_1.configInstance.getBaseUrl();
    }
}
exports.Route = Route;
//# sourceMappingURL=route.js.map